// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__I8WzB","errors":"Errors_errors__1UfSm"};